import { Injectable } from '@angular/core';
import { LookupPipe } from '../pipes/lookup.pipe';

@Injectable({
  providedIn: 'root'
})
export class FormatterService {

  constructor(
    private lookupPipe: LookupPipe
  ) {
  }

  public lookupFormatter(lookupName) {
    return (dataItemValue) => {
      return this.lookupPipe.transform(dataItemValue, lookupName);
    };
  }
}
